
export interface LicenseListState {
}

export function EmptyLicenseListState(): LicenseListState {
    return { };
}
